import { render } from "./App.vue?vue&type=template&id=109fbec2&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=109fbec2&lang=scss&scoped=true"

import exportComponent from "/Users/zhangzhiyuan/vue_project/public-demo-vue3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-109fbec2"]])

export default __exports__